import { TeamTurns } from "../../../../domain/model/Game";
import { Grid, IconButton, Stack } from "@mui/material";
import { CustomCardView } from "../../../component/CustomCardView";
import {
  COLOR_BLACK,
  COLOR_GOLD,
  COLOR_LIGHT_GRAY,
  COLOR_MAIN,
  COLOR_VERY_LIGHT_GRAY,
  COLOR_WHITE,
} from "../../../../data/colors/Colors";
import { getDifficultyInfo } from "../../../../core/utils/Utils";
import { CustomTextView } from "../../../component/CustomTextView";
import { CountdownTimer } from "./QuestionView";
import { useTranslation } from "react-i18next";
import { QuestionAnswerDetailsView } from "./QuestionAnswerDetailsView";
import { CustomButtonView } from "../../../component/CustomButtonView";
import { StarRounded } from "@mui/icons-material";

export function QuestionMobileView({
  onClosePopover,
  viewModel,
}: {
  onClosePopover: ({ who }: { who?: string }) => void;
  viewModel: any;
}) {
  const { t, i18n } = useTranslation();

  const gameData = viewModel.gameData;
  const question = viewModel.question;
  const answer = viewModel.answer;

  const countdownTimerVisible = !viewModel.bothTeamAnswered;

  return (
    <>
      {!gameData || !question || !answer ? (
        "ERROR"
      ) : (
        <>
          <Grid
            container
            height={"100%"}
            width={"100%"}
            spacing={0}
            sx={{ direction: "ltr" }}
          >
            <Grid size={8} sx={{ pr: 1 }}>
              <CustomCardView
                width={"100%"}
                height={"100%"}
                padding={1.5}
                background={COLOR_MAIN}
                borderRadius={4}
                children={
                  <Stack width={"100%"} height={"100%"} spacing={1}>
                    {viewModel.bothTeamAnswered && viewModel.showWhoAnswered ? (
                      <Stack
                        width={"100%"}
                        height={"100%"}
                        justifyContent={"center"}
                        alignItems={"center"}
                        spacing={1}
                      >
                        <Stack
                          direction={"row"}
                          width={"100%"}
                          alignItems={"center"}
                          justifyContent={"center"}
                          spacing={1}
                        >
                          <Stack width={"100%"}>
                            <CustomButtonView
                              onClick={() => {
                                onClosePopover({
                                  who: gameData.firstTeamName,
                                });
                              }}
                              text={gameData.firstTeamName}
                              backgroundColor={COLOR_WHITE}
                              textColor={COLOR_MAIN}
                            />
                          </Stack>
                          <Stack width={"100%"}>
                            <CustomButtonView
                              onClick={() => {
                                onClosePopover({
                                  who: gameData.secondTeamName,
                                });
                              }}
                              text={gameData.secondTeamName}
                              backgroundColor={COLOR_WHITE}
                              textColor={COLOR_MAIN}
                            />
                          </Stack>
                        </Stack>

                        <Stack width={"100%"}>
                          <CustomButtonView
                            onClick={() => {
                              onClosePopover({});
                            }}
                            text={t("no_one_answered")}
                            backgroundColor={COLOR_WHITE}
                            textColor={COLOR_MAIN}
                          />
                        </Stack>
                      </Stack>
                    ) : (
                      <Stack
                        width={"100%"}
                        height={"100%"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                        gap={1}
                      >
                        <QuestionAnswerDetailsView
                          question={question}
                          answer={answer}
                          showAnswer={viewModel.showAnswer}
                          isMobile
                        />
                        <Stack
                          width={"100%"}
                          alignItems={"center"}
                          justifyContent={"space-between"}
                          direction={"row"}
                          gap={2}
                        >
                          {!viewModel.bothTeamAnswered ? (
                            <CustomButtonView
                              onClick={viewModel.onAnswerButtonClicked}
                              text={`${
                                gameData.currentTeamTurn == TeamTurns.teamA
                                  ? !viewModel.hasFirstTeamAnswered
                                    ? gameData.firstTeamName
                                    : gameData.secondTeamName
                                  : !viewModel.hasFirstTeamAnswered
                                    ? gameData.secondTeamName
                                    : gameData.firstTeamName
                              } ${t("answered")}`}
                              backgroundColor={COLOR_VERY_LIGHT_GRAY}
                              textColor={COLOR_BLACK}
                              props={{ pl: 2, pr: 2 }}
                              elevation={12}
                              fontSize="body1"
                            />
                          ) : (
                            <Stack width={"100%"}>
                              {
                                <CustomButtonView
                                  onClick={() => {
                                    viewModel.setShowWhoAnswered(true);
                                  }}
                                  text={t("who_answered")}
                                  backgroundColor={COLOR_VERY_LIGHT_GRAY}
                                  textColor={COLOR_BLACK}
                                  props={{ pl: 2, pr: 2 }}
                                  fontSize="body1"
                                />
                              }
                            </Stack>
                          )}

                          {viewModel.bothTeamAnswered && (
                            <Stack width={"100%"}>
                              <CustomButtonView
                                onClick={() => {
                                  viewModel.setShowAnswer(
                                    !viewModel.showAnswer,
                                  );

                                  viewModel.setShowWhoAnswered(false);
                                }}
                                text={
                                  viewModel.showAnswer
                                    ? t("see_question")
                                    : t("see_answer")
                                }
                                backgroundColor={COLOR_VERY_LIGHT_GRAY}
                                textColor={COLOR_BLACK}
                                props={{ pl: 2, pr: 2 }}
                                fontSize="body1"
                              />
                            </Stack>
                          )}
                        </Stack>
                      </Stack>
                    )}
                  </Stack>
                }
              />
            </Grid>
            <Grid size={4}>
              <Stack
                width={"100%"}
                height={"100%"}
                alignItems={"center"}
                gap={1}
              >
                <CustomCardView
                  width={"100%"}
                  height={!countdownTimerVisible ? "100%" : "70%"}
                  background={COLOR_MAIN}
                  borderRadius={4}
                  padding={1.5}
                  children={
                    <Stack width={"100%"} height={"100%"} gap={2}>
                      <Stack
                        direction={"row"}
                        gap={2}
                        width={"100%"}
                        height={"100%"}
                      >
                        {viewModel.bothTeamAnswered && (
                          <IconButton
                            sx={{
                              border: "solid 2px " + COLOR_GOLD,
                              width: "4vw",
                              height: "4vw",
                            }}
                            onClick={() =>
                              viewModel.setGiveFeedbackDialogOpen(true)
                            }
                          >
                            <StarRounded
                              sx={{ color: COLOR_GOLD }}
                              fontSize="small"
                            />
                          </IconButton>
                        )}
                        <Stack
                          width={"100%"}
                          height={"100%"}
                          alignItems={"end"}
                          gap={0}
                        >
                          <CustomTextView
                            text={question.category?.title}
                            fontWeight="bold"
                            textAlign="center"
                            variant="body1"
                            textColor={COLOR_WHITE}
                          />
                          <CustomTextView
                            text={
                              getDifficultyInfo(question.difficulty ?? "", t)
                                .text
                            }
                            fontWeight="bold"
                            variant="body2"
                            textAlign="center"
                            textColor={
                              getDifficultyInfo(question.difficulty ?? "", t)
                                .color
                            }
                          />
                        </Stack>
                      </Stack>

                      <Stack gap={0.5} sx={{ direction: i18n.dir() }}>
                        <Stack
                          direction={"row"}
                          width={"100%"}
                          justifyContent={"space-between"}
                          alignItems={"center"}
                          gap={1}
                        >
                          <CustomTextView
                            text={gameData?.firstTeamName}
                            fontWeight="bold"
                            variant="h5"
                            textColor={"lightGray"}
                          />

                          <CustomTextView
                            text={gameData?.firstTeamScore?.toString()}
                            fontWeight="bold"
                            variant="h6"
                            textColor={COLOR_WHITE}
                          />
                        </Stack>
                      </Stack>
                      <Stack gap={0.5} sx={{ direction: i18n.dir() }}>
                        <Stack
                          direction={"row"}
                          width={"100%"}
                          justifyContent={"space-between"}
                          alignItems={"center"}
                          gap={1}
                        >
                          <CustomTextView
                            text={gameData?.secondTeamName}
                            fontWeight="bold"
                            variant="h5"
                            textColor={"lightGray"}
                          />

                          <CustomTextView
                            text={gameData?.secondTeamScore?.toString()}
                            fontWeight="bold"
                            variant="h6"
                            textColor={COLOR_WHITE}
                          />
                        </Stack>
                      </Stack>
                    </Stack>
                  }
                />

                {countdownTimerVisible && (
                  <CustomCardView
                    width={"100%"}
                    height={"30%"}
                    padding={2}
                    background={COLOR_MAIN}
                    borderRadius={4}
                    children={
                      <Stack width={"100%"} height={"100%"}>
                        <CountdownTimer
                          counter={viewModel.countdownTimerSeconds}
                          hasFirstTeamAnswered={viewModel.hasFirstTeamAnswered}
                          setPausedResumed={viewModel.setTimerPausedOrResumed}
                          setCounter={(c) =>
                            viewModel.setCountdownTimerSeconds(c)
                          }
                          isMobile
                        />
                      </Stack>
                    }
                  />
                )}
              </Stack>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
}
